import { useContext } from "react";
import { CartContext } from "../../Contexts/CartContext";
import styles from "./CartScreen.module.scss";
import stylesProductCard from "../ProductCard/ProductCard.module.scss";

import { IoCloseOutline } from "react-icons/io5";
import { getWeightInfo } from "../../utils/helpers";
import { Divider } from "antd";

const CartTableMobile = () => {
  const cartContext = useContext(CartContext);
  return (
    <div className={styles.cart_mobile_item_wrapper}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          // backgroundColor: "#f7eac8",
          fontWeight: 600,
          fontSize: "2rem",
        }}
        className={"px-3 py-1"}
      >
        <span style={{ color: "var(--color-primary)" }}>Your Items ({cartContext.cartItems.length})</span>
        {/* <span>Quantity</span> */}
      </div>
      {cartContext.cartItems.map((item, index) => {
        return (
          <>
            <CartItem key={index} item={item} />
            {index !== cartContext.cartItems.length - 1 && (
              <Divider className="divider-100" />
            )
            }
          </>
        )
      })}
    </div>
  );
};

export default CartTableMobile;

const CartItem = ({ item }) => {
  // useEffect(()=>{
  //     console.log(item);
  // }, []);

  const cartContext = useContext(CartContext);

  const addToCart = () => {
    cartContext.addToCart(item);
  };

  //defining increaseQty function
  const increaseQty = () => {
    addToCart();
  };

  const decreaseQty = () => {
    cartContext.cartItemDecrement(item.id);
  };

  return (
    <div className={styles.cart_mobile_item}>
      <div className={"d-flex align-items-center"} style={{ gap: "1rem" }}>
        <div style={{ minWidth: "60px", width: "60px" }}>
          <img className={styles.product_image} src={item.image} alt="img" />
        </div>

        <div className={"d-flex flex-column"} style={{ width: "100%" }}>
          <div >
            <span
              style={{
                // marginBottom: 4,
                // width: 200,
                display: "flex",
                gap: 4,
                alignItems: 'flex-end',
                color: "var(--color-grey)",
              }}
            >
              <span style={{ color: "var(--color-primary)", lineHeight: "1.1em", fontWeight: "bold", fontSize: "1.9rem" }}>
                {item.order_time_price} €
              </span>
              {item.variant.discount_percentage ? (
                <>
                  {/* <span style={{ fontSize: 12 }}>{item.order_time_price} €</span> */}
                  <span style={{ color: "var(--color-red)", fontSize: "1.2rem" }}>
                    ({item.variant.price} €)
                  </span>
                </>
              ) : null}
            </span>

          </div>
          <div
            style={{
              color: "var(--color-dark)",
              fontWeight: 600,
              fontSize: "1.45rem",
              lineHeight: "1.2em",
            }}
          >
            {item.title}
          </div>
          <div className={styles.title_and_variant} style={{ lineHeight: "unset", fontSize: "1rem", minHeight: "1rem" }}>
            <span
              style={{
                fontWeight: 500,
                color: "var(--color-grey)",
                fontSize: "1rem",
                lineHeight: "1em",
              }}
            >
              {getWeightInfo(item.variant, item.order_time_price)}
            </span>
          </div>
        </div>

        <div className="d-flex flex-column align-items-end justify-content-between" style={{ minHeight: "60px" }}>
          <div
            className={styles.cross_mobile}
            onClick={() => cartContext.removeFromCart(item.id)}
          >
            <IoCloseOutline
              size={20}
              color="var(--color-red)"
              onClick={null}
            />
          </div>
          <div
            className={`
                ${stylesProductCard.ProductAddToCart} 
                ${stylesProductCard.ProductAddToCart_amount}`}
          >
            {
              item.quantity > 0 ? (
                <div>
                  <img
                    src="/icon/minus.svg"
                    alt="minus"
                    onClick={decreaseQty}
                  />
                  <div className={stylesProductCard.stock_amount}>{item.quantity}</div>
                  <img
                    src="icon/plus.svg"
                    alt="plus"
                    onClick={increaseQty}
                  />
                </div>

              ) : (
                <></>
              )
            }
          </div>
        </div>



        {/* <div
          className={"d-flex align-items-center"}
          style={{ marginLeft: "auto" }}
        >
          <div
            style={{ marginTop: 15 }}
            className={styles.product_quantity_actions}
          >
            <AiFillMinusCircle
              size={18}
              onClick={decreaseQty}
              color={"var(--color-primary)"}
            />
            <div className={styles.stock_amount}>{item.quantity}</div>
            <BsFillPlusCircleFill
              size={18}
              onClick={increaseQty}
              color={"var(--color-primary)"}
            />
          </div>
        </div> */}
      </div>
    </div>
  );
};
